import { PostDto } from '../../../../common/interfaces/infoboard.interface';
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { ReactComponent as ImportantIcon } from '../../../../assets/important-icon.svg';
import { ReactComponent as EditIcon } from '../../../../assets/edit-icon.svg';
import { ReactComponent as WarningIcon } from '../../../../assets/warning-icon.svg';
import dayjs from 'dayjs';
import GenericFile from '../../../../components/GenericFile';
import { useNavigate } from 'react-router-dom';
import { ProfilePictureAvatar } from '../../../../common/styles/Common.styles';
import { WarningBox } from '../PostPage/PostPage.styles';
import { TopRightEditImportantBox } from './PostItem.styles';
import { INFOBOARD } from '../../../../common/constants/routes.constants';

interface PostItemProps {
  post: PostDto;
}

const PostItem: React.FC<PostItemProps> = ({ post }) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`${INFOBOARD}/post/${post.id}/edit`);
  };
  return (
    <Box
      sx={{
        border: post.important ? '1px solid rgba(229, 128, 122, 0.35)' : '1px solid #E0E0E0',
        borderRadius: '10px',
        position: 'relative'
      }}
    >
      <Box
        sx={{
          padding: '16px 12px',
          borderBottom: '1px solid #F0F0F0',
          backgroundColor: '#FBFBFC',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <ProfilePictureAvatar src={post.creatorPicture ?? undefined} width={48} height={48}></ProfilePictureAvatar>
          <Box>
            <Typography variant="caption">{post.createdBy}</Typography>
            <Typography variant="body2" color="text.secondary">
              {dayjs(post.updatedAt).format('DD.MM.YYYY. HH:mm')}
            </Typography>
          </Box>
        </Box>

        {(post.canEdit || post.important) && (
          <TopRightEditImportantBox important={post.important}>
            {post.canEdit && (
              <IconButton onClick={handleEdit} sx={{ p: 1 }} size="small">
                <EditIcon width={20} height={20} />
              </IconButton>
            )}

            {post.important && (
              <WarningBox>
                <ImportantIcon style={{ width: 15, height: 15, display: 'block' }} />
                <Typography variant="caption" color="error" fontWeight={600}>
                  Important
                </Typography>
              </WarningBox>
            )}
          </TopRightEditImportantBox>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '24px',
          padding: '12px'
        }}
      >
        <Typography variant="body1" color="#7D8189">
          {post.description}
        </Typography>
        {post.hasPollItem && (
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              color: '#3F749C'
            }}
          >
            <WarningIcon />
            <Typography variant="body1">To see poll details check in app.</Typography>
          </Box>
        )}
      </Box>

      {post.files && post.files.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            padding: '12px',
            flexWrap: 'wrap'
          }}
        >
          {post.files.map(file => (
            <GenericFile key={file.id} file={file} />
          ))}
        </Box>
      )}
    </Box>
  );
};
export default PostItem;
